"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var Tracker_1 = __importDefault(require("../../../Utils/Tracker"));
var reconnect_js_1 = require("reconnect.js");
function SearchInput(props) {
  var search = props.search,
    updateSearch = props.updateSearch;
  var _a = react_1.default.useState(search),
    value = _a[0],
    setValue = _a[1];
  var AppActions = (0, reconnect_js_1.useOutlet)('actions')[0];
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(antd_1.Input.Search, {
    value: value,
    onChange: function (e) {
      setValue(e.target.value);
    },
    placeholder: AppActions.L('keyword'),
    onSearch: function () {
      updateSearch(value);
      Tracker_1.default.keywordSearch({
        keyword: value
      });
    },
    style: {
      width: 150
    }
  }));
}
exports.default = SearchInput;